export default {
  order: {
    create: "orders.create",
    cancel: "orders.cancel",
    complete: "orders.complete",
    copy: "orders.copy",
    save: "orders.save",
    close: "orders.close",
    schedule: "orders.schedule",
    unschedule: "orders.unschedule",
    setTimeFrame: "orders.set_timeframe",
    calculate: "orders.calculate",
    consolidate: "orders.consolidate",
    messageCustomer: "orders.message_customer",
    customerNotReady: "orders.customer_not_ready",
    receive: "orders.receive",
    printBol: "orders.print_bol",
    palletize: "orders.palletize",
    geocodeAddress: "orders.geocode_address",
    view: {
      audit: "orders.view.audit",
      map: "orders.view.map",
      crn: "orders.view.crn",
      billTo: "orders.view.bill_to",
      carrier: "orders.view.carrier",
      deliveryType: "orders.view.delivery_type",
      facility: "orders.view.facility",
      manufacturer: "orders.view.manufacturer",
      truck: "orders.view.truck",
      codPending: "orders.view.cod_pending",
      intermediateConsignee: "orders.view.intermediate_consignee",
      remark: "orders.view.remark",
      specialRequest: "orders.view.special_request",
      dates: "orders.view.dates",
      orderBy: "orders.view.order_by",
      shipper: "orders.view.shipper",
      consignee: "orders.view.consignee",
      consigneeContact: "orders.view.consignee_contact",
      commodity: "orders.view.commodity",
      rating: "orders.view.rating",
      note: "orders.view.note",
      referenceNumber: "orders.view.reference_number",
      barcode: "orders.view.barcode",
      image: "orders.view.image",
      consolidatedOrder: "orders.view.consolidated_order",
      accessorial: "orders.view.accessorial"
    },
    edit: {
      crn: "orders.edit.crn",
      billTo: "orders.edit.bill_to",
      carrier: "orders.edit.carrier",
      deliveryType: "orders.edit.delivery_type",
      facility: "orders.edit.facility",
      manufacturer: "orders.edit.manufacturer",
      codPending: "orders.edit.cod_pending",
      intermediateConsignee: "orders.edit.intermediate_consignee",
      remark: "orders.edit.remark",
      specialRequest: "orders.edit.special_request",
      shipDate: "orders.edit.ship_date",
      estReceiveDate: "orders.edit.est_receive_date",
      requestedDeliveryDate: "orders.edit.req_del_date",
      dockSearchDate: "orders.edit.dock_search_date",
      orderBy: "orders.edit.order_by",
      shipper: "orders.edit.shipper",
      consignee: "orders.edit.consignee",
      consigneeContact: "orders.edit.consignee_contact",
      commodity: "orders.edit.commodity",
      commodityUnit: "orders.edit.commodity_unit",
      rating: "orders.edit.rating",
      note: "orders.edit.note",
      referenceNumber: "orders.edit.reference_number",
      accessorial: "orders.edit.accessorial",
      image: "orders.edit.image"
    },
    add: {
      consigneeContact: "orders.add.consignee_contact",
      commodity: "orders.add.commodity",
      note: "orders.add.note",
      referenceNumber: "orders.add.reference_number",
      accessorial: "orders.add.accessorial",
      image: "orders.add.image"
    },
    delete: {
      note: "orders.delete.note",
    },
  },
  agents: {
    companies: {
      create: "agents.companies.create",
    },
    order: {
      create: "agents.orders.create",
      close: "agents.orders.close",
      cancel: "agents.orders.cancel",
      complete: "agents.orders.complete",
      copy: "agents.orders.copy",
      schedule: "agents.orders.schedule",
      unschedule: "agents.orders.unschedule",
      setTimeFrame: "agents.orders.set_timeframe",
      calculate: "agents.orders.calculate",
      consolidate: "agents.orders.consolidate",
      messageCustomer: "agents.orders.message_customer",
      customerNotReady: "agents.orders.customer_not_ready",
      receive: "agents.orders.receive",
      printBol: "agents.orders.print_bol",
      palletize: "agents.orders.palletize",
      geocodeAddress: "agents.orders.geocode_address",
      view: {
        map: "agents.orders.view.map",
        consignee: "agents.orders.view.consignee",
        dates: "agents.orders.view.dates",
        audit: "agents.orders.view.audit",
        note: "agents.orders.view.note",
      },
      add: {
        note: "agents.orders.add.note",
        image: "agents.orders.add.image"
      },
      edit: {
        note: "agents.orders.edit.note",
      },
      delete: {
        note: "agents.orders.delete.note",
      },
    },
    barcodeSystem: {
      orders: {
        view: "agents.barcode.orders.view",
        itemgps: {
          view: "agents.barcode.orders.view.itemgps"
        },
        items: {
          save: "agents.barcode.orders.save.items"
        },
        noScanLineItems: {
          save: "agents.barcode.orders.save.noscanlineitems"
        }
      }
    }
  },
  companies: {
    view: "companies.view",
    create: "companies.create",
    setId: "companies.set_id"
  },
  manage: {
    groups: "manage.groups",
    roles: "manage.roles",
    users: "VisionOps.CdsITUserManagement",
    deliveryExport: "manage.deliveryExport",
    completedOrderExport: 'manage.completedOrderExport',
    facilities: "manage.facilities",
    customerOnHold: {
      view: "manage.customerOnHold.view",
      update: "manage.customerOnHold.update"
    },
    billTo: {
      commodities: "manage.bill_to.commodities",
      manufacturers: "manage.bill_to.manufacturers"
    },
    facilitySavedOrderSearches: "manage.facility_saved_order_searches",
    commodityUnloadTimeOverride: "manage.commodity_unload_time_override",
    commodityUnloadTimeDefaults: "manage.commodity_unload_time",
    timeframeSchedulingSettings: "manage.timeframeSchedulingSettings",
    timeframeSchedulingDefaultSettings: "manage.timeframeSchedulingDefaultSettings",
    drivers: "manage.drivers",
    truckTemplate: "manage.truckTemplate",
    truckZip3Overrides: "manage.truckZip3Overrides",
    orderTypeToDeliveryTypeMappings: "manage.orderTypeToDeliveryTypeMappings",
    barcodeSystem: "manage.barcodeSystem",
    asnMap: "manage.asnMap",
    agents: {
      view: "manage.agents.view",
      add: "manage.agents.add",
      edit: "manage.agents.edit",
      configurationEdit: "manage.agents.configurationedit",
      deliveryFor: {
        view: "manage.agents.deliveryfor.view",
        add: "manage.agents.deliveryfor.add",
        edit: "manage.agents.deliveryfor.edit",
        delete: "manage.agents.deliveryfor.delete"
      },
      facility: {
        view: "manage.agents.facility.view",
        add: "manage.agents.facility.add",
        delete: "manage.agents.facility.delete"
      },
      company: {
        view: "manage.agents.company.view",
        add: "manage.agents.company.add",
        edit: "manage.agents.company.edit",
      },
      manufacturer: {
        view: "manage.agents.manufacturer.view",
        add: "manage.agents.manufacturer.add",
        edit: "manage.agents.manufacturer.edit"
      },
      deliveryType: {
        view: "manage.agents.deliverytype.view",
        add: "manage.agents.deliverytype.add",
        edit: "manage.agents.deliverytype.edit",
      },
      commodity: {
        view: "manage.agents.commodity.view",
        add: "manage.agents.commodity.add",
        edit: "manage.agents.commodity.edit"
      },
      referenceType: {
        view: "manage.agents.referencetype.view",
        add: "manage.agents.referencetype.add",
        edit: "manage.agents.referencetype.edit",
        delete: "manage.agents.referencetype.delete"
      },
      chargeType: {
        view: "manage.agents.chargetype.view",
        add: "manage.agents.chargetype.add",
        edit: "manage.agents.chargetype.edit",
        delete: "manage.agents.chargetype.delete"
      },
      setting: {
        view: "manage.agents.setting.view",
        add: "manage.agents.setting.add",
        edit: "manage.agents.setting.edit",
        delete: "manage.agents.setting.delete"
      },
      users: "VisionOps.AgentUserManagement",
      asnMap: "manage.agents.asnMap"
    }
  },
  truck: {
    create: "trucks.create",
    split: "trucks.split",
    combine: "trucks.combine",
    addOrder: "trucks.add_order",
    edit: "trucks.edit",
    view: {
      detail: "trucks.view.detail",
      revenue: "trucks.view.revenue"
    }
  },
  barcodeSystem: {
    inventory: {
      view: "barcode.inventory.view",
      update:  "barcode.inventory.update",
      delete:  "barcode.inventory.delete",
      resolve:  "barcode.inventory.resolve",
      link: "barcode.inventory.link",
      adjustStock: "barcode.inventory.adjustStock"
    },
    stockSku: {
      create: "barcode.stocksku.create"
    },
    requiredStock: {
      save: "barcode.requiredstock.save"
    },
    load: {
      view: "barcode.load.view",
      unlock: "barcode.load.unlock",
      consolidate: "barcode.load.consolidate"
    },
    orders: {
      view: "barcode.orders.view",
      itemgps: {
        view: "barcode.orders.view.itemgps"
      },
      items: {
        save: "barcode.orders.save.items"
      },
      noScanLineItems: {
        save: "barcode.orders.save.noscanlineitems"
      }
    },
    manifest: {
      view: "barcode.manifest.view",
      create: "barcode.manifest.create",
      hide: "barcode.manifest.hide",
      restore: "barcode.manifest.restore",
      gps: {
        view: "barcode.manifest.view.gps"
      }
    },
    stockOrders: {
      view: "barcode.stockorder.view",
      create: "barcode.stockorder.create",
      receive: "barcode.stockorder.receive",
      cancel: "barcode.stockorder.cancel",
      unlock: "barcode.stockorder.unlock"
    },
    companies: {
      view: "barcode.companies.view",
      manage: "barcode.companies.manage"
    },
    warehouseLocations: {
      update: "barcode.warehouseLocation.update",
      unlock: "barcode.warehouseLocation.unlock"
    }
  },
  document: {
    batchIndex: "dms.bi",
    paperless: "dms.paperless"
  }
};
